export default {
  title: "Myeuroservice",
  version: "1.2.1"
};
